<div class="flex-row">
    <div class="sidebar-next-right-block">
        <partner-settings-business-info [menuPermissionActive]="menuPermissionActive" 
                                        *ngIf="activeMenu === menuEnum.BusinessInfo"
                                        [businessInfo]="businessInfo"></partner-settings-business-info>

        <partner-settings-legal-documents [menuPermissionActive]="menuPermissionActive" [legalDocs]="legalDocs" *ngIf="activeMenu === menuEnum.LegalDocuments" 
                                          [activeDocumentItem]="activeMenuLevel3Item"></partner-settings-legal-documents>

        <partner-settings-payout-account [menuPermissionActive]="menuPermissionActive" *ngIf="activeMenu === menuEnum.PayoutAccount"></partner-settings-payout-account>

        <partner-settings-authorized-representative [menuPermissionActive]="menuPermissionActive" [merchantInfo]="businessInfo" 
                                                    *ngIf="activeMenu === menuEnum.AuthorizedRepresentative"></partner-settings-authorized-representative>

        <partner-settings-partnership-terms [menuPermissionActive]="menuPermissionActive" [merchantInfo]="businessInfo" 
                                            *ngIf="activeMenu === menuEnum.PartnershipTerms"></partner-settings-partnership-terms>
    </div>
</div>

<p-toast position="top-right"></p-toast>
